import { DigitalMenuBasicInfoInterface } from "@/interface/business/digital-menu.interface";
import PhoneModule from "@/modules/phone";
import { PhoneModuleInterface } from "@/interface/phone";

export default class DigitalMenuBasicInfo implements DigitalMenuBasicInfoInterface {
  phone_number: PhoneModuleInterface;
  email: string = "";
  address: string = "";
  website: string = "";

  constructor(data?) {
    Object.assign(this, data);
    this.phone_number = new PhoneModule(data?.phone_number || "");
    this.email = data?.email || "";
    this.address = data?.address || "";
    this.website = data?.website || "";
  }
}
